<template>
  <div>
    <div
      v-if="$store.state.user.userDetails.is_super"
      class="d-flex justify-end mb-3"
    >
      <v-btn class="btn btn-primary" to="/traction">
        <i aria-hidden="true" class="v-icon mdi mdi-chart-line mr-1"></i>
        Traction Metrics
      </v-btn>
    </div>
    <widgets-dropdown></widgets-dropdown>
  </div>
</template>

<script>
const WidgetsDropdown = () => import("@/views/widgets/WidgetsDropdown.vue");

export default {
  name: "Dashboard",
  components: {
    "widgets-dropdown": WidgetsDropdown,
  },
};
</script>
